import React, {useState} from "react";

const CouponCodeField = ({activeCouponCode, errorMessage, onApply, onRemove}) => {
    const [showInput, setShowInput] = useState(false);
    const [inputValue, setInputValue] = useState("");

    if (activeCouponCode) {
        return (
            <div className="flex items-center mt-1">
                <span className="text-sm text-gray-600 bg-gray-100 px-2 py-1 rounded">
                    Gutscheincode aktiv: {activeCouponCode}
                </span>
                <button
                    onClick={() => {
                        setInputValue("");
                        setShowInput(false);
                        onRemove();
                    }}
                    className="ml-2 text-red-500 hover:text-red-700"
                    title="Coupon entfernen"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                </button>
            </div>
        );
    }

    if (!showInput) {
        return (
            <button
                onClick={() => setShowInput(true)}
                className="text-pegasusPurple hover:text-pink-700 text-sm underline"
            >
                Hast du einen Gutscheincode?
            </button>
        );
    }

    return (
        <div className="mt-2">
            <div className="flex">
                <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => {
                        const newValue = e.target.value;
                        setInputValue(newValue);
                        if (!newValue) {
                            onRemove();
                        }
                    }}
                    placeholder="Gutscheincode"
                    className="border border-gray-300 rounded-l-lg px-3 py-1 text-sm w-full"
                />
                <button
                    onClick={() => onApply(inputValue)}
                    className="bg-pegasusPurple text-white px-3 py-1 rounded-r-lg text-sm hover:bg-pegasusPurpleHover"
                >
                    Anwenden
                </button>
            </div>
            {errorMessage && (
                <p className="text-red-500 text-xs mt-1">{errorMessage}</p>
            )}
        </div>
    );
};

export default CouponCodeField;
